import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import '../../Styles/NavBar.css';

const NavBar = () => (


    <Navbar collapseOnSelect expand="lg" className="o-nav">
        <Navbar.Toggle className="o-btn-menu" aria-controls="responsive-navbar-nav"  />
        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-center">
            <Nav className="justify-content-center o-navb">
                <Nav.Link href="#" className="active o-linkNav">
                    <Link to="/" className="active nav-link">Profile</Link>
                </Nav.Link>
                <Nav.Link href="#" className="o-linkNav">
                    <Link to="/resume" className="nav-link">Resume</Link>
                </Nav.Link>
                <Nav.Link href="#" className="o-linkNav">
                    <Link to="/areas-of-expertise" className="nav-link">Expertise</Link>
                </Nav.Link>
                <Nav.Link href="#" className="o-linkNav">
                    <Link to="/portfolio" className="nav-link">Portfolio</Link>
                </Nav.Link>
                <Nav.Link href="#" className="o-linkNav">
                    <Link to="/contact" className="nav-link">Contact</Link>
                </Nav.Link>
            </Nav>
        </Navbar.Collapse>
    </Navbar>

);
export default NavBar;